import Form from './Form';


Form.install = function(Vue) {
  Vue.component(Form.name, Form);
};

export default Form;
